module.exports = __webpack_public_path__ + "img/uebungsdienstwasser1.2479f469.jpg";